import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _, { isEmpty } from 'lodash';
import { Box } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import GridItem from '../../components/Grid/GridItem';
import CustomTypography from '../../components/Typography/CustomTypography';
import GridContainer from '../../components/Grid/GridContainer';
import TableProductPaymentDetail from '../../components/TableProductPaymentDetail/TableProductPaymentDetail';
import { headerTableOrder, lavenderTableOrder, navyColor } from '../../assets/jss/global';
import styles from '../../assets/jss/pages/CartViewerStyle';
import Button from '../../components/Button/CustomButton';
import SelectorInput from '../../components/Input/SelectorInput';
import CustomTable from '../../components/Table/Table';
import Pagination from '../../components/Pagination/Pagination';
import DialogProcessOrderProduct from '../../containers/cartViewer/DialogProcessOrderProduct';
import Loader from '../../components/Loader/Loader';
import DialogHistoryOrderProduct from '../../containers/cartViewer/DialogHistoryOrderProduct';
import SnackBar from '../../components/Snackbar/Snackbar';
import ViewHeader from '../../components/Header/ViewHeader';

const useStyles = makeStyles(styles);

export const Header = (props) => {
    const { eventInfo } = props;
    const intl = useIntl();
    return (
        <>
            {!_.isEmpty(eventInfo) && (
                <ViewHeader
                    eventName={eventInfo.name}
                    title={eventInfo?.settings_texts_sidebar_viewer?.field_name?.cart
                        ? eventInfo?.settings_texts_sidebar_viewer?.field_name?.cart
                        : intl.formatMessage({ id: 'userRouters.shoppingCart' })}
                    isIntl={false}
                    eventInfo={eventInfo}
                />
            )}
        </>
    );
};

Header.defaultProps = {
    eventInfo: {},
};

Header.propTypes = {
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
};

const CartViewer = ({
    getListProductCart,
    clearProduct,
    isLoading,
    listProductOrder,
    getListHistoryOrder,
    listHistory,
    clearListHistoryOrder,
    deleteProduct,
    clearDeleteProduct,
    successDeleteProduct,
    clearChangeQuantity,
    changeQuantityProduct,
    successChangeQuantity,
    errorQuantityProduct,
    getCount,
    eventInfo,
    customText,
    customColor,
    customPersonInfo,
    locale,
}) => {
    const classes = useStyles(customColor);
    const { shortName } = useParams();
    const intl = useIntl();

    const [listProduct, setListProduct] = useState([]);
    const [titleProduct, setTitleProduct] = useState([]);
    const [listSellProduct, setListSellProduct] = useState([]);
    const [listHistoryOrder, setListHistoryOrder] = useState({});
    const [tableHistoryOrder, setTableHistoryOrder] = useState([]);
    const [openDialogOrder, setOpenDialogOrder] = useState(false);
    const [openDetailHistory, setOpenDetailHistory] = useState(false);
    const [idHistory, setIdHistory] = useState(null);
    const [isOpenSnackBar, setIsOpenSnackBar] = useState({ isOpen: false, content: '' });
    const [productNoQuantity, setProductNoQuantity] = useState('');

    const totalQuantity = (number) => {
        let total = {};
        const currentNumber = (number >= 10 || !number) ? 10 : number;
        // eslint-disable-next-line no-return-assign
        Array.from(Array(currentNumber).keys()).forEach((item) => total = { ...total, [item + 1]: item + 1 });
        return total;
    };

    useEffect(() => {
        if (shortName) {
            getListHistoryOrder({ page_size: 10, language: locale });
            getListProductCart({ language: locale });
        }
        return () => {
            clearProduct();
            clearListHistoryOrder();
            clearDeleteProduct();
            clearChangeQuantity();
        };
    }, [shortName, locale]);

    useEffect(() => {
        if (!_.isEmpty(listProductOrder)) {
            setListProduct(listProductOrder);
        }
    }, [listProductOrder]);

    useEffect(() => {
        if (!_.isEmpty(listHistory)) {
            setListHistoryOrder(listHistory);
        }
    }, [listHistory]);

    useEffect(() => {
        if (listProduct.data) {
            allSellProduct();
            titleSellProduct();
            noProduct();
        }
    }, [listProduct, eventInfo]);

    useEffect(() => {
        if (listHistoryOrder) {
            setTableHistoryOrder(listHistoryOrder.results);
        }
    }, [listHistoryOrder, eventInfo]);

    useEffect(() => {
        if (successDeleteProduct) {
            getListProductCart({ language: locale });
            getCount();
            clearDeleteProduct();
        }
    }, [successDeleteProduct, locale]);

    useEffect(() => {
        if (!_.isEmpty(successChangeQuantity)) {
            getListProductCart({ language: locale });
            clearChangeQuantity();
        }
    }, [successChangeQuantity, locale]);

    useEffect(() => {
        if (!_.isEmpty(errorQuantityProduct)) {
            setIsOpenSnackBar({ isOpen: true, content: errorQuantityProduct.message.message });
            clearProduct();
            clearChangeQuantity();
            getListProductCart({ language: locale });
        }
    }, [errorQuantityProduct, locale]);

    const titleSellProduct = () => {
        const title = (listProduct.data || []).map((item) => [item.full_name]);
        setTitleProduct(title);
    };

    const sellProduct = (data) => {
        const product = [];
        (data.products || []).forEach((item) => {
            const currentQuantity = (+item.available < +item.quantity) ? +item.available : +item.quantity;
            product.push([
                item.name,
                `${intl.formatNumber(item.price)}${intl.formatMessage({ id: 'common.yen' })}`,
                <div className={+item.available ? classes.selectProduct : classes.disableSelect}>
                    <SelectorInput
                        variant="standard"
                        valueSelected={+item.available ? currentQuantity : +item.quantity}
                        optionList={totalQuantity(+item.available)}
                        onChange={(valueInput) => handleChangeQuantity(item.id, totalQuantity(+item.available)[valueInput])}
                        errorTable={errorQuantityProduct}
                        customColor={customColor?.contents_text_color}
                    />
                </div>,
                <Button
                    onClick={() => handleDeleteProduct(item.id)}
                    color="danger"
                    style={{ fontSize: '14px' }}
                    buttonTextColor={eventInfo?.settings_colors_viewer?.button_text_color}
                    buttonBackgroundColor={eventInfo?.settings_colors_viewer?.button_background_color?.shopping_button}
                >
                    {intl.formatMessage({ id: 'delete' })}
                </Button>,
            ]);
        });
        product.push([
            intl.formatMessage({ id: 'shopping.postage' }),
            `${intl.formatNumber(data.shipping_cost)}${intl.formatMessage({ id: 'common.yen' })}`,
            '', '']);
        product.push([
            intl.formatMessage({ id: 'shopping.subtotal' }),
            `${intl.formatNumber(data.price_total)}${intl.formatMessage({ id: 'common.yen' })}`,
            data.quantity_total, '']);
        return product;
    };

    const allSellProduct = () => {
        const allSell = (listProduct.data || []).map((item) => sellProduct(item));
        setListSellProduct(allSell);
    };

    const noProduct = () => {
        let noQuantity = '';
        (listProduct.data || []).forEach((item) => {
            (item.products || []).forEach((product) => {
                if (!product.available) noQuantity = noQuantity === '' ? noQuantity.concat('', product.name) : noQuantity.concat(', ', product.name);
            });
        });
        setProductNoQuantity(noQuantity);
    };

    const handleDeleteProduct = (id) => {
        deleteProduct({ delete_id: id });
    };

    const handleChangeQuantity = (id, value) => {
        changeQuantityProduct({ product_id: id, quantity: value });
    };

    const handleProcessToOrder = () => {
        if (productNoQuantity) {
            const textError = intl.formatMessage({ id: 'shopping.removeProduct' }, { nameProduct: productNoQuantity });
            setIsOpenSnackBar({ isOpen: true, content: textError });
        } else {
            setOpenDialogOrder(true);
        }
    };

    const handleDetailHistoryOrder = (id) => {
        setOpenDetailHistory(true);
        setIdHistory(id);
    };

    const handleSearchWithPage = (changePage) => {
        getListHistoryOrder({ page: changePage, page_size: 10, language: locale });
    };

    const createTable = (viewlist) => {
        const dataTableHeader = [
            customText?.field_name?.order_number || intl.formatMessage({ id: 'shopping.orderNumber' }),
            customText?.field_name?.order_date || intl.formatMessage({ id: 'shopping.orderDate' }),
            customText?.field_name?.payment_method || intl.formatMessage({ id: 'shopping.paymentMethod' }),
            customText?.field_name?.payment_status || intl.formatMessage({ id: 'seminar.paymentStatus' }),
            customText?.field_name?.order_details || intl.formatMessage({ id: 'shopping.orderDetail' }),
        ];
        const dataTable = (viewlist || []).map((item) => [
            item.order_no,
            item.order_date,
            +item.payment_method === 1 ? intl.formatMessage({ id: 'common.credit' }) : intl.formatMessage({ id: 'common.bankTransfer' }),
            item.is_paid,
            <div className={classes.colCenter}>
                <Button
                    onClick={() => handleDetailHistoryOrder(item.id)}
                    color="navy"
                    style={{ fontSize: '14px' }}
                    buttonTextColor={eventInfo?.settings_colors_viewer?.button_text_color}
                    buttonBackgroundColor={eventInfo?.settings_colors_viewer?.button_background_color?.common_button}
                >
                    {customText?.button_name?.show_breakdown || intl.formatMessage({ id: 'shopping.showBreakdown' })}
                </Button>
            </div>,
        ]);
        return (
            <GridContainer>
                <GridItem>
                    <CustomTable
                        cellTextColorHear={customColor?.list_table?.title_text_color}
                        cellTextColorBody={customColor?.contents_text_color}
                        cellBackgroundColor={customColor?.list_table}
                        tableHead={dataTableHeader}
                        tableHeadWidth={['20%', '20%', '20%', '20%', '20%']}
                        colorRowTitle={customColor?.shop_table?.sub_title_background_color || lavenderTableOrder}
                        tableData={dataTable}
                        cellColor={customColor?.list_table?.title_background_color || navyColor}
                        hover={false}
                        tableFooter={(
                            <Box display="flex" justifyContent="center">
                                <Pagination
                                    page={listHistoryOrder.page}
                                    total={listHistoryOrder.total_page}
                                    onChange={(changePage) => handleSearchWithPage(changePage)}
                                    colorBackgroundCustom={customColor?.list_table?.odd_record_background_color}
                                    colorTextCustom={customColor?.button_background_color?.common_button}
                                />
                            </Box>
                        )}
                    />
                </GridItem>
            </GridContainer>
        );
    };

    return (
        <>
            <Loader isLoading={isLoading} />
            {!_.isEmpty(eventInfo) && (
                <>
                    {(listProduct.data || []).length ? (
                        <GridContainer>
                            <GridItem>
                                <CustomTypography variant="h5" xs={12} bold className={classes.spacingViewer} customColor={customColor?.contents_text_color}>
                                    {intl.formatMessage({ id: 'shopping.itemCart' }, {
                                        nameCart: eventInfo?.settings_texts_sidebar_viewer?.field_name?.cart
                                        || intl.formatMessage({ id: 'userRoutes.cart' }).toLowerCase(),
                                    })}
                                </CustomTypography>
                            </GridItem>
                            <GridItem>
                                <TableProductPaymentDetail
                                    cellColor={customColor?.shop_table?.title_background_color || headerTableOrder}
                                    colorRowTitle={customColor?.shop_table?.sub_title_background_color || lavenderTableOrder}
                                    onClick={() => {}}
                                    tableHead={[
                                        customText?.field_name?.product_name || intl.formatMessage({ id: 'productRegister.productName' }),
                                        intl.formatMessage({ id: 'shopping.unitPrice' }),
                                        intl.formatMessage({ id: 'shopping.quantity' }),
                                        intl.formatMessage({ id: 'common.action' }),
                                    ]}
                                    tableHeadWidth={['55%', '20%', '10%', '15%']}
                                    tableTitleRow={titleProduct}
                                    tableData={listSellProduct}
                                    hover={false}
                                    pointerLess
                                    className={classes.customTable}
                                    lengthCol={4}
                                    cellBackgroundColor={customColor?.shop_table?.record_background_color}
                                    cellTextColorHear={customColor?.contents_text_color}
                                    cellTextColorBody={customColor?.contents_text_color}
                                />
                            </GridItem>
                            <GridItem>
                                <CustomTypography variant="h5" xs={12} bold className={classes.spacingPrice} customColor={customColor?.contents_text_color}>
                                    {`${intl.formatMessage({ id: 'shopping.total' })}:`}
                                    <span className={classes.allTotalPrice}>
                                        {`${intl.formatNumber(listProduct.all_total_price)}${intl.formatMessage({ id: 'common.yen' })}`}
                                    </span>
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                    ) : ''}
                    {(listProduct.data || []).length ? (
                        <GridContainer
                            direction="row"
                            justify="center"
                            alignItems="center"
                            className={classes.historyOrder}
                        >
                            <Button
                                color="navy"
                                round
                                gradient
                                className={classes.buttonBig}
                                onClick={() => handleProcessToOrder()}
                                buttonTextColor={customColor?.button_text_color}
                                buttonBackgroundColor={customColor?.button_background_color?.common_button}
                            >
                                <b>{customText?.button_name?.order_procedure || intl.formatMessage({ id: 'shopping.oderProcedure' })}</b>
                            </Button>
                        </GridContainer>
                    ) : ''}
                    <GridContainer
                        direction="row"
                        justify="center"
                        alignItems="center"
                    >
                        <CustomTypography variant="h5" color="navy" xs={12} bold className={classes.spacingTitleHistory} customColor={customColor?.screen_name_text_color}>
                            { intl.formatMessage({ id: 'shopping.orderHistory' })}
                        </CustomTypography>
                    </GridContainer>
                    {!_.isEmpty(tableHistoryOrder) && !isLoading && createTable(tableHistoryOrder)}
                    <DialogProcessOrderProduct
                        isOpen={openDialogOrder}
                        handleClose={() => setOpenDialogOrder(false)}
                        eventName={shortName}
                        customColor={customColor}
                        customText={customText}
                        customPersonInfo={customPersonInfo}
                    />
                    <DialogHistoryOrderProduct
                        isOpen={openDetailHistory}
                        handleClose={() => setOpenDetailHistory(false)}
                        idHistoryOrder={idHistory}
                    />
                </>
            )}
            <SnackBar
                open={isOpenSnackBar.isOpen}
                onClose={() => setIsOpenSnackBar(false)}
                message={isOpenSnackBar.content}
                severity="error"
                autoHideDuration={3000}
            />
        </>
    );
};

CartViewer.defaultProps = {
    getListProductCart: () => {},
    clearProduct: () => {},
    getListHistoryOrder: () => {},
    clearListHistoryOrder: () => {},
    isLoading: false,
    listProductOrder: {},
    listHistory: {},
    deleteProduct: () => {},
    clearDeleteProduct: () => {},
    successDeleteProduct: false,
    clearChangeQuantity: () => {},
    changeQuantityProduct: () => {},
    successChangeQuantity: {},
    errorQuantityProduct: {},
    getCount: () => {},
    eventInfo: {},
    customText: {},
    customColor: {},
    customPersonInfo: {},
    locale: 'ja',
};

CartViewer.propTypes = {
    getListProductCart: PropTypes.func,
    clearProduct: PropTypes.func,
    getListHistoryOrder: PropTypes.func,
    clearListHistoryOrder: PropTypes.func,
    isLoading: PropTypes.bool,
    listProductOrder: PropTypes.oneOfType([() => null, PropTypes.object]),
    listHistory: PropTypes.oneOfType([() => null, PropTypes.object]),
    deleteProduct: PropTypes.func,
    clearDeleteProduct: PropTypes.func,
    successDeleteProduct: PropTypes.bool,
    clearChangeQuantity: PropTypes.func,
    changeQuantityProduct: PropTypes.func,
    successChangeQuantity: PropTypes.oneOfType([() => null, PropTypes.object]),
    errorQuantityProduct: PropTypes.oneOfType([() => null, PropTypes.object]),
    getCount: PropTypes.func,
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    customText: PropTypes.oneOfType([() => null, PropTypes.object]),
    customColor: PropTypes.oneOfType([() => null, PropTypes.object]),
    customPersonInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    locale: PropTypes.string,
};

export default CartViewer;
